// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillTosDataView } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTos from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTos";
import translate from "@insite/client-framework/Translate";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";
import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown";
// import React, { FC, useEffect, useState } from "react"; // Greif Custom Code
import { connect, ResolveThunks } from "react-redux";

/* Greif Custom Code - Start */
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import Tooltip from "@insite/mobius/Tooltip";
import { getCookie } from "@insite/mobius/utilities/cookies";
import constants from "@store/constants";
import { useHasPageLoadedWithMultipleCustomer } from "@store/Extensions/Store/Pages/ChangeCustomer/ChangeCustomerHooks";
import debounce from "lodash/debounce";
import React, { FC, useCallback, useEffect, useState } from "react";
/* Greif Custom Code - End */

interface OwnProps {
    noShipToAndCantCreate: boolean;
    setParameter: (parameter: GetBillTosApiParameter) => void;
    parameter: GetBillTosApiParameter;
    billTo?: BillToModel;
    onSelect: (billTo: BillToModel) => void;
    extendedStyles?: ChangeCustomerBillToSelectorStyles;
    isLoading?: boolean;
    soldTosInstructions?: string;
}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => ({
    billTosDataView: getBillTosDataView(state, props.parameter),
    customerSettings: getSettingsCollection(state).customerSettings,
    currentBillToState: getCurrentBillToState(state),
});

const mapDispatchToProps = {
    loadBillTos,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ChangeCustomerBillToSelectorStyles {
    billToSelectorDynamicDropdown?: DynamicDropdownPresentationProps;
}

export const changeCustomerBillToSelectorStyles: ChangeCustomerBillToSelectorStyles = {};

const ChangeCustomerBillToSelector: FC<Props> = ({
    noShipToAndCantCreate,
    parameter,
    setParameter,
    billTo,
    onSelect,
    extendedStyles,
    isLoading,
    billTosDataView,
    // Greif Custom Code
    soldTosInstructions,
    currentBillToState,
}) => {
    const [styles] = useState(() => mergeToNew(changeCustomerBillToSelectorStyles, extendedStyles));
    const [options, setOptions] = useState<OptionObject[]>([]);

    /* Greif Custom Code - Start */
    const hasMultipleCustomers = useHasPageLoadedWithMultipleCustomer(billTosDataView.value);
    const [inputText, setInputText] = useState<string>();
    /* Greif Custom Code - End */

    useEffect(() => {
        if (billTosDataView.value) {
            const options: OptionObject[] = billTosDataView.value.map(billTo => ({
                optionText: billTo.label,
                optionValue: billTo.id,
            }));
            setOptions(options);
            /* Greif Custom Code - Start */
            const showChangeCustomerPageVariantCookie = getCookie(constants.cookies.showChangeCustomerPageVariant);

            if (billTosDataView.value.length === 1 && !hasMultipleCustomers && showChangeCustomerPageVariantCookie) {
                onSelect(billTosDataView.value[0]);
            }
            /* Greif Custom Code - End */
        }
    }, [billTosDataView]);

    /* Greif Custom Code - Start */
    const debouncedSearchBillto = useCallback(
        debounce((query: string) => {
            setParameter({
                ...parameter,
                filter: query,
            });
        }, 300),
        [setParameter],
    );
    /* Greif Custom Code - End */

    const searchTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        /* Greif Custom Code - Start */
        const newValue = event.currentTarget.value;
        setInputText(newValue);
        debouncedSearchBillto(newValue);
        /* Greif Custom Code - End */
    };

    const selectCustomerHandler = (billToId?: string) => {
        if (billTosDataView.value && billToId) {
            const billTo = billTosDataView.value.filter(billTo => billTo.id === billToId)[0];
            if (billTo) {
                onSelect(billTo as BillToModel);
            }
        }
    };

    /* Greif Custom Code - Start */
    const oneBillToId =
        billTosDataView.value && billTosDataView.value.length === 1 && !hasMultipleCustomers
            ? billTosDataView.value[0].id
            : undefined;
    const selectedItemId = oneBillToId || billTo?.id;

    const onCloseHandler = () => {
        if (billTo) {
            setInputText(undefined);

            const selectedOption = options.find(x => x.optionValue === billTo.id);

            if (selectedOption) {
                setOptions(options);
            } else {
                setOptions([
                    {
                        optionText: billTo.label,
                        optionValue: billTo.id,
                    },
                ]);
            }
            setParameter({
                ...parameter,
                filter: undefined,
            });
        }
    };

    useEffect(() => {
        const currentBillTo = currentBillToState && currentBillToState.value;
        if (currentBillTo) {
            onSelect(currentBillTo as BillToModel);
        }
    }, []);

    useEffect(() => {
        const selectedOption = options.find(x => x.optionValue === billTo?.id);
        if (!!billTo && !selectedOption && !inputText) {
            setOptions(opt => [
                ...opt,
                {
                    optionText: billTo?.label || "",
                    optionValue: billTo?.id,
                },
            ]);
        }
    }, [options, billTo, inputText]);

    /* Greif Custom Code - End */

    return (
        <DynamicDropdown
            /* Greif Custom Code - Start */
            label={
                <>
                    {translate("Select Bill To")}
                    {soldTosInstructions && <Tooltip text={soldTosInstructions} />}
                </>
            }
            /* Greif Custom Code - End */
            {...styles.billToSelectorDynamicDropdown}
            onSelectionChange={selectCustomerHandler}
            onInputChange={searchTextChanged}
            selected={selectedItemId} // Greif
            disabled={!!oneBillToId} // Greif
            options={options}
            placeholder={translate("Search or Select Bill To")}
            isLoading={isLoading}
            /* Greif Custom Code - Start */
            onClose={onCloseHandler}
            /* Greif Custom Code - End */
            error={noShipToAndCantCreate && siteMessage("SignIn_NoShipToAndCantCreate")}
            data-test-selector="changeCustomerBillToSelector"
            filterOption={() => true}
            uid="ChangeCustomerBillToSelector" // Starter Custom Code
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeCustomerBillToSelector);
